import React from 'react';
import { Loading } from '@nike/nike-design-system-icons';
import { SpinnerProps } from '../../types/SpinnerProps';
import '@nike/nike-design-tokens/dist/css/tokens.css';
import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';

const spin = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`;

const StyledSpinner = styled(Loading)`
  animation-name: ${spin};
  animation-duration: var(--podium-cds-motion-duration-400);
  animation-timing-function: var(--podium-cds-motion-easing-functional);
  animation-iteration-count: infinite;
`;

const Spinner: React.FC<SpinnerProps> = ({ size = 'md', className }) => {
  return (
    <div className={className} data-testid="spinner">
      <StyledSpinner size={size as any} />
    </div>
  );
};

export default Spinner;
